import { render } from "./ReadingIndexView.vue?vue&type=template&id=812cfed0&lang=true"
import script from "./ReadingIndexView.vue?vue&type=script&lang=js"
export * from "./ReadingIndexView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__